module.exports = __webpack_public_path__ + "img/timer.39e5adc9.svg";